'use client'

import { AnimatedSpan, Terminal, TypingAnimation } from '@/components/magicui/terminal'
import { cn } from '@/lib/utils'
import { Check, Loader2Icon } from 'lucide-react'
import { ComponentProps } from 'react'

export function CliAutomationSdkHeroVisual({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div className={cn('w-full', className)}>
      <Terminal className={'max-h-none min-h-[550px] w-full max-w-full'}>
        <TypingAnimation duration={30}>
          &gt; npx vendure add plugin erp-sync-plugin --with-ui
        </TypingAnimation>

        <AnimatedSpan
          delay={2000}
          className={'flex items-center gap-2 text-yellow-300'}
        >
          <Loader2Icon
            size={20}
            className="animate-spin"
          />
          Analyzing project...
        </AnimatedSpan>

        <AnimatedSpan
          delay={2100}
          className={'flex items-center gap-2 text-green-500'}
        >
          <Check size={20} />
          Created directory
          <code className={'text-muted-foreground'}>src/plugins/erp-sync-plugin</code>
        </AnimatedSpan>

        <AnimatedSpan
          delay={2200}
          className={'flex items-center gap-2 text-green-500'}
        >
          <Check size={20} />
          Created plugin file
          <code className={'text-muted-foreground'}>
            src/plugins/erp-sync-plugin/erp-sync.plugin.ts
          </code>
        </AnimatedSpan>

        <AnimatedSpan
          delay={2300}
          className={'flex items-center gap-2 text-green-500'}
        >
          <Check size={20} />
          Created UI entry point
          <code className={'text-muted-foreground'}>src/plugins/erp-sync-plugin/ui/index.ts</code>
        </AnimatedSpan>

        <AnimatedSpan
          delay={2400}
          className={'flex items-center gap-2 text-green-500'}
        >
          <Check size={20} />
          Added plugin to config
          <code className={'text-muted-foreground'}>src/vendure-config.ts</code>
        </AnimatedSpan>

        <AnimatedSpan
          delay={2500}
          className="text-blue-500"
        >
          <span>ℹ Added 3 files to your project</span>
          <span className="pl-2">- src/plugins/erp-sync-plugin/ui/index.ts</span>
          <span className="pl-2">- src/plugins/erp-sync-plugin/erp-sync.plugin.ts</span>
          <span className="pl-2">- src/plugins/erp-sync-plugin/src/index.ts</span>
        </AnimatedSpan>

        <TypingAnimation
          delay={2600}
          className="text-muted-foreground"
        >
          Success! Created your plugin "erp-sync-plugin" now.
        </TypingAnimation>
      </Terminal>
    </div>
  )
}
